var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol-content"},_vm._l((_vm.protocols),function(protocol){return _c('p',{staticStyle:{"text-align":"justify"}},[_vm._v(" "+_vm._s(protocol))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }